import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import partialCheckoutRedemption from "../fragments/partialCheckoutRedemption"

const query = gql`
  query CheckoutRedemptions($userId: ID, $cursor: String, $isUsed: Boolean, $types: [CheckoutRedemptionType!]) {
    checkoutRedemptions(userId: $userId, cursor: $cursor, isUsed: $isUsed, types: $types) {
      results {
        ...partialCheckoutRedemption
      }
      limit
      hasMore
      cursor
    }
  }
  ${partialCheckoutRedemption}
`

export const redemptionListQueryKey = getQueryNames(query)[0]

export default query
